"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OcrPresetNameSchema = exports.OcrPresetName = void 0;
exports.isOcrPresetName = isOcrPresetName;
const zod_1 = require("zod");
var OcrPresetName;
(function (OcrPresetName) {
    OcrPresetName["AzureOcr"] = "azure-ocr";
})(OcrPresetName || (exports.OcrPresetName = OcrPresetName = {}));
exports.OcrPresetNameSchema = zod_1.z.nativeEnum(OcrPresetName);
function isOcrPresetName(name) {
    return Object.values(OcrPresetName).includes(name);
}
//# sourceMappingURL=ocr-presets.js.map